/* eslint-disable no-console */
import firebase from '~/config/firebase';

type INotification = {
  title: string;
  body: string;
};

type ICallback = (n: INotification) => void;

export const onReceiveMessaging = (callback: ICallback) => {
  if ('Notification' in window) {
    const messaging = firebase.messaging();
    messaging.onMessage(({ notification }) => {
      callback(notification);
    });
  }
};

export const askForNotifications = async () => {
  try {
    const messaging = firebase.messaging();
    return await messaging
      .getToken()
      .then(token => {
        console.info('Token obtido com sucesso.');
        return { token };
      })
      .catch(error => {
        console.info('Erro ao obter token.', error?.code);
        throw { code: error?.code };
      });
  } catch (error) {
    return { code: error?.code };
  }
};
